/**
@ngdoc directive
@name digitalSignature

@description
Widget for capturing and displaying a users signature

@usage
    <digital-signature
        id:                         string            // ensures the component can be differentiated on the page if there are multiple
        image-get-url:              string            // endpoint to check for a previously saved signature image
        ng-hidden:                  boolean
        ng-required:                boolean           // uses custom validation to update form if the user has interacted with component
        ng-disabled:                boolean
        helper-text:                string            // text to be displayed at bottom of component in invalid form input
	></digital-signature>
*/

(function () {
  "use strict";

  var digitalSignature = function ($http, $templateCache) {
    return {
      restrict: "EA",
      scope: {
        id: "@",
        imageGetUrl: "@",
        label: "@",
        helperText: "@",
        ngHidden: "@",
        ngRequired: "@",
        ngDisabled: "@",
      },
      replace: true,
      transclude: false,
      template: $templateCache.get("formWidget/digitalSignature.html"),
      controller: [
        "$scope",
        function ($scope) {
          $scope.saved = false;
          $scope.imageBase = "";
          $scope.error = false;

          var canvas,
            canvasContext,
            canvasWidth,
            canvasHeight,
            flag = false,
            prevX = 0,
            currX = 0,
            prevY = 0,
            currY = 0,
            dot_flag = false;

          var colour = "black";
          var lineWidth = 1;
          var firstTouch = true;
          var timeout;

          $scope.onLoad = function () {
            canvas = document.getElementById("canvas-" + $scope.id);
            if (!canvas) {
              setTimeout(function () {
                $scope.onLoad();
              }, 500);
              return;
            }
            canvasContext = canvas.getContext("2d");
            canvasWidth = canvas.width;
            canvasHeight = canvas.height;

            canvasContext.fillStyle = "white";
            canvasContext.fillRect(0, 0, canvasWidth, canvasHeight);

            if ($scope.ngDisabled == "false") {
              addEventListeners();
            }

            drawSavedImageToCanvas();
          };

          $scope.clear = function (userCleared) {
            if ($scope.ngDisabled == "true") return;
            canvasContext.clearRect(0, 0, canvasWidth, canvasHeight);
            if (userCleared) {
              firstTouch = true;
              applyWatermark();
            }
            $scope.saved = false;
            $scope.imageBase = "";
          };

          $scope.clearError = function () {
            this.error = false;
          };

          function drawSavedImageToCanvas() {
            checkForSavedImage()
              .then(function (response) {
                var imageData = response.data;
                if (imageData) {
                  var savedImage = new Image();
                  savedImage.onload = function () {
                    canvasContext.drawImage(savedImage, 0, 0);
                  }.bind(this);
                  savedImage.src = imageData;
                  firstTouch = false;
                  save(imageData);
                } else {
                  applyWatermark();
                }
              })
              .catch(function () {
                $scope.error = true;
                applyWatermark();
              });
          }

          function checkForSavedImage() {
            return $http.get(WEBAPP_PATH + "/" + $scope.imageGetUrl, {});
          }

          function save(src) {
            if (src) {
              $scope.imageBase = src;
            } else {
              var dataURL = canvas.toDataURL();
              $scope.imageBase = dataURL;
            }
            $scope.saved = true;
          }

          function applyWatermark() {
            canvasContext.fillStyle = "#999";
            canvasContext.textAlign = "center";
            canvasContext.fillText(
              "Use your mouse or touchscreen to sign here",
              canvasWidth / 2,
              canvasHeight / 2
            );
          }

          function draw() {
            canvasContext.beginPath();
            canvasContext.moveTo(prevX, prevY);
            canvasContext.lineTo(currX, currY);
            canvasContext.strokeStyle = colour;
            canvasContext.lineWidth = lineWidth;
            canvasContext.stroke();
            canvasContext.closePath();
          }

          function findxy(res, e) {
            var boundingRect = e.target.getBoundingClientRect();
            if (res == "down") {
              if (firstTouch) {
                $scope.clear();
                firstTouch = false;
              }

              if (timeout) {
                clearTimeout(timeout);
                $scope.saved = false;
              }
              prevX = currX;
              prevY = currY;
              currX = e.clientX - boundingRect.left;
              currY = e.clientY - boundingRect.top;
              flag = true;
              dot_flag = true;

              if (dot_flag) {
                canvasContext.beginPath();
                canvasContext.fillStyle = colour;
                canvasContext.fillRect(currX, currY, lineWidth, lineWidth);
                canvasContext.closePath();
                dot_flag = false;
              }
            }
            if (res == "up" || res == "out") {
              if (flag) {
                timeout = setTimeout(function () {
                  save();
                }, 500);
              }
              flag = false;
            }
            if (res == "move" || res == "touchmove") {
              if (flag) {
                prevX = currX;
                prevY = currY;
                currX = e.clientX - boundingRect.left;
                currY = e.clientY - boundingRect.top;
                draw();
              }
            }
          }

          function addEventListeners() {
            canvas.addEventListener(
              "mousemove",
              function (e) {
                findxy("move", e);
              },
              false
            );
            canvas.addEventListener(
              "mousedown",
              function (e) {
                findxy("down", e);
              },
              false
            );
            canvas.addEventListener(
              "mouseup",
              function (e) {
                findxy("up", e);
              },
              false
            );
            canvas.addEventListener(
              "mouseout",
              function (e) {
                findxy("out", e);
              },
              false
            );
            canvas.addEventListener(
              "touchmove",
              function (e) {
                findxy("move", e.touches[0]);
              },
              false
            );
            canvas.addEventListener(
              "touchstart",
              function (e) {
                findxy("down", e.touches[0]);
                e.preventDefault();
              },
              false
            );
            canvas.addEventListener(
              "touchend",
              function (e) {
                findxy("up", e);
              },
              false
            );
          }
        },
      ],
      require: "^form",
    };
  };
  digitalSignature.$inject = ["$http", "$templateCache"];
  angular.module("app").directive("digitalSignature", digitalSignature);
})();

app.directive("signatureRequired", function () {
  return {
    require: "ngModel",
    restrict: "A",
    link: function (scope, elem, attr, ngModel) {
      ngModel.$validators.signatureRequired = function (modelValue) {
        return modelValue;
      };
    },
  };
});
